<header class="header-area header-sticky" [class.scrolled]="isScrolled" [class.about-theme]="isAboutPage">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <nav class="main-nav">
                    <a (click)="routeToPage('/')" class="logo navbar-brand">
                        <img src="assets/img/logo/yogamez-hub-dark-480.png" srcset="assets/img/logo/yogamez-hub-dark-240.png 240w, assets/img/logo/yogamez-hub-dark-480.png 480w" sizes="(max-width: 480px) 120px, (max-width: 768px) 140px, 205px" alt="YoGamez HUB" width="205" height="79" fetchpriority="high">
                    </a>

                    <ul class="nav default-font">
                        <li><a routerLink="/" [class.active]="isActive('./')" class="default-font" (click)="closeMenu()">Home</a></li>
                        <li><a routerLink="games" [class.active]="isActive('games')" (click)="closeMenu()">Play</a></li>
                        <li *ngIf="userDetails==null"><a routerLink="signup" [class.active]="isActive('signup')" (click)="closeMenu()">Subscribe</a></li>
                        <li *ngIf="userDetails!=null"><a routerLink="leaderboard" [class.active]="isActive('leaderboard')" (click)="closeMenu()">Leaderboard</a></li>
                        <li><a routerLink="about-us" [class.active]="isActive('about-us')" (click)="closeMenu()">About Us</a></li>
                    </ul>

                    <div class="nav-right">
                        <div class="search-icon" (click)="toggleSearch()">
                            <i class="fa fa-search"></i>
                        </div>

                        <a routerLink="support" class="support-link" [class.active]="isActive('support')" (click)="closeMenu()">Support</a>

                        <div class="profile-section">
                            <a *ngIf="userDetails==null" routerLink="signup" class="join-now-btn" [class.active]="isActive('signup')" (click)="closeMenu()">
                                Join Now
                            </a>

                            <div class="nav-item dropdown" *ngIf="userDetails!=null">
                                <a class="nav-link dropdown-toggle profile-btn" href="#" id="loggedInprofileDropdown"
                                   role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ userDetails.username.length > 8 ? (userDetails.username | slice:0:8) + '...' : userDetails.username }}
                                    <img src="../../../../assets/img/profile/profile-header.jpg" alt="Profile">
                                </a>
                                <div class="dropdown-menu" aria-labelledby="loggedInprofileDropdown">
                                    <a class="dropdown-item" routerLink="profile" [class.active]="isActive('profile')" (click)="closeMenu()">My Profile</a>
                                    <a class="dropdown-item" routerLink="leaderboard" [class.active]="isActive('leaderboard')" (click)="closeMenu()">Leaderboard</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" (click)="logout()">Log Out</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <a class='menu-trigger' (click)="toggleMenu()">
                        <span></span>
                    </a>

                    <div class="search-input-overlay" [class.active]="searchActive">
                        <form id="search" (submit)="onSearch($event)">
                            <input type="text" placeholder="Search games..." id="searchText"
                                   name="searchKeyword" [(ngModel)]="searchKeyword"
                                   (keyup.enter)="onSearch($event)" />
                            <i class="fa fa-times close-search" (click)="toggleSearch()"></i>
                        </form>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</header>
